// extracted by mini-css-extract-plugin
export default {"form":"AnswerForm_form__bevhA","button":"AnswerForm_button__ddfCY"};